/**
 * Industry types for corporations in Parkington.
 * Each corporation belongs to one industry, and families need one subscription per industry.
 */
export enum IndustryType {
  FUEL = 'FUEL',
  GROCERY = 'GROCERY',
  RETAIL = 'RETAIL',
  INSURANCE = 'INSURANCE',
  TELECOM = 'TELECOM',
  HEALTHCARE = 'HEALTHCARE',
}

export type PaymentModel = 'at_visit' | 'recurring';

export interface IndustryConfig {
  type: IndustryType;
  label: string;
  icon: string;
  accentColor: string;
  paymentModel: PaymentModel;
  paymentAmount: number;
  recurringInterval: number; // ms, only relevant for recurring
}

export const INDUSTRY_CONFIGS: Record<IndustryType, IndustryConfig> = {
  [IndustryType.FUEL]: {
    type: IndustryType.FUEL,
    label: 'Gas Station',
    icon: '⛽',
    accentColor: '#e63946',
    paymentModel: 'at_visit',
    paymentAmount: 8,
    recurringInterval: 0,
  },
  [IndustryType.GROCERY]: {
    type: IndustryType.GROCERY,
    label: 'Grocery Store',
    icon: '🛒',
    accentColor: '#4a9e4a',
    paymentModel: 'at_visit',
    paymentAmount: 12,
    recurringInterval: 0,
  },
  [IndustryType.RETAIL]: {
    type: IndustryType.RETAIL,
    label: 'Big Box Retail',
    icon: '🏬',
    accentColor: '#e9c46a',
    paymentModel: 'at_visit',
    paymentAmount: 15,
    recurringInterval: 0,
  },
  [IndustryType.INSURANCE]: {
    type: IndustryType.INSURANCE,
    label: 'Insurance Co.',
    icon: '📋',
    accentColor: '#4a90a4',
    paymentModel: 'recurring',
    paymentAmount: 5,
    recurringInterval: 10000,
  },
  [IndustryType.TELECOM]: {
    type: IndustryType.TELECOM,
    label: 'Telecom Corp',
    icon: '📡',
    accentColor: '#9b59b6',
    paymentModel: 'recurring',
    paymentAmount: 4,
    recurringInterval: 10000,
  },
  [IndustryType.HEALTHCARE]: {
    type: IndustryType.HEALTHCARE,
    label: 'Health Clinic',
    icon: '🏥',
    accentColor: '#2a9d8f',
    paymentModel: 'recurring',
    paymentAmount: 6,
    recurringInterval: 10000,
  },
};

export const ALL_INDUSTRIES = Object.values(IndustryType);
